import { useCallback, useState } from "react";
import { activeConversationExitGuard } from "./futureFollowUpGuard.mjs";
import {
  centralConversationExitOwner,
  findCentralConversationRecord,
} from "./centralConversationExit.mjs";
import useFutureFollowUpExit from "./useFutureFollowUpExit";
import { noteConversationSelection } from "./conversationDiagnostics.mjs";

export default function useCentralConversationSelection({ records, normalizePhone, onMarkRead, exitOptions }) {
  const [selection, setSelection] = useState({ phone:null, storeId:null });
  const selectedPhone = selection.phone;
  const selectedStoreId = selection.storeId;
  const activeCentralRecord = findCentralConversationRecord(records, selectedStoreId, selectedPhone, normalizePhone);
  const owner = centralConversationExitOwner(activeCentralRecord, selectedStoreId, selectedPhone, normalizePhone);
  const centralExitGuard = useFutureFollowUpExit(activeCentralRecord, owner, () => {
    setSelection({ phone:null, storeId:null });
  }, exitOptions);

  const runNavigation = useCallback(action => {
    return activeConversationExitGuard.requestAction(action);
  }, []);

  const selectConversation = useCallback((phone, storeId, { markReadKey, afterSelect } = {}) => {
    const sameConversation = selectedPhone != null
      && normalizePhone(phone) === normalizePhone(selectedPhone)
      && Number(storeId) === Number(selectedStoreId);
    const changeSelection = () => {
      noteConversationSelection(storeId, normalizePhone(phone));
      setSelection({ phone, storeId });
      if (markReadKey) onMarkRead?.(markReadKey);
      afterSelect?.();
    };

    if (selectedPhone != null && !sameConversation) {
      if (!runNavigation(changeSelection)) return false;
    } else {
      changeSelection();
    }

    return true;
  }, [normalizePhone, onMarkRead, runNavigation, selectedPhone, selectedStoreId]);

  return {
    selectedPhone,
    selectedStoreId,
    activeCentralRecord,
    centralExitGuard,
    selectConversation,
    runNavigation,
  };
}